import { getSavedState, saveState } from './helpers.js';

export default {
    namespaced: true,

    state: () => ({
        list: getSavedState('permissionList') || 0,
    }),

    getters: {
        list(state) {
            return state.list;
        },
    },

    mutations: {
        SET_LIST(state, newValue) {
            state.list = newValue;
            saveState('permissionList', newValue);
        },
    },

    actions: {
        setList({ commit }, newValue) {
            commit('SET_LIST', newValue);
        },
    },
};